import { CONTRACT_TYPES } from '../../../../constants/reports/reports-data';

const capitalizeFirstLetter = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

export const handlePerpetuals = (riskType: string, breakdowns: any[], perpetualType: string) => {
  const contractName = `${CONTRACT_TYPES.PERPETUAL} (${perpetualType})`;

  const totalBreakdown = breakdowns.find(
    (bk: any) => bk.contract === contractName && bk.instrument === CONTRACT_TYPES.TOTAL,
  );

  if (!totalBreakdown) {
    return null;
  }

  const values = totalBreakdown.risk || [];

  const children = breakdowns
    .filter((bk: any) => bk.contract === contractName && bk.instrument !== CONTRACT_TYPES.TOTAL)
    .map((bk: any) => ({
      id: `${riskType}-${bk.instrument}`,
      label: bk.instrument,
      position: bk.position,
      values: bk.risk,
    }));

  return {
    id: `${riskType}-perpetual-${perpetualType.toLowerCase()}`,
    label: `Perpetuals (${capitalizeFirstLetter(perpetualType)})`,
    position: 'Position',
    values: values,
    children: children,
  };
};
